var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77812 19.7782C2.3876 20.1687 2.3876 20.8019 2.77812 21.1924C3.16865 21.5829 3.80181 21.5829 4.19234 21.1924L11.9705 13.4142L19.7487 21.1924C20.1392 21.5829 20.7724 21.5829 21.1629 21.1924C21.5535 20.8019 21.5535 20.1687 21.1629 19.7782L13.3847 12L21.1629 4.22182C21.5534 3.83129 21.5534 3.19813 21.1629 2.8076C20.7724 2.41708 20.1392 2.41708 19.7487 2.8076L11.9705 10.5858L4.19237 2.80761C3.80184 2.41709 3.16868 2.41709 2.77815 2.80761C2.38763 3.19814 2.38763 3.8313 2.77815 4.22183L10.5563 12L2.77812 19.7782Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLarge);
export default __webpack_public_path__ + "static/media/close-large.77a5cbf90c22e60c08779b192ef1340a.svg";
export { ForwardRef as ReactComponent };